import { Component, AfterViewInit, inject } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-login',
  standalone: false,
  template: `
    <div class="login-wrapper">
      <div class="login-left">
        <img src="assets/logo.png" alt="Banner Audit" class="logo" />
        <h1>Banner Audit</h1>
        <p>Consultá el historial de cambios en los diseños de tus clientes.</p>
        <div class="decorative-circles">
          <span class="circle c1"></span>
          <span class="circle c2"></span>
          <span class="circle c3"></span>
        </div>
      </div>
      <div class="login-right">
        <div id="auth0-lock-container"></div>
      </div>
    </div>
  `,
  styles: [`
    .login-wrapper {
      min-height: 100vh;
      display: flex;
    }

    .login-left {
      flex: 1;
      background: linear-gradient(180deg, #FFE2F5 0%, rgba(203, 252, 255, 0.6) 100%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 60px 48px;
      position: relative;
      overflow: hidden;
    }
    .logo { width: 140px; margin-bottom: 24px; }
    h1 { margin: 0 0 12px; font-size: 32px; font-weight: 700; color: #2e1e5b; text-align: center; }
    p { margin: 0; font-size: 15px; color: #4b3880; text-align: center; line-height: 1.6; max-width: 320px; }

    .decorative-circles { position: absolute; inset: 0; pointer-events: none; }
    .circle {
      position: absolute; border-radius: 50%;
      background: rgba(255,255,255,0.25);
    }
    .c1 { width: 260px; height: 260px; bottom: -80px; left: -60px; }
    .c2 { width: 180px; height: 180px; top: -40px; right: -40px; }
    .c3 { width: 100px; height: 100px; top: 40%; left: 20px; background: rgba(75,56,128,0.08); }

    .login-right {
      width: 520px;
      background: #f8f8f8;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 60px 48px;
    }

    @media (max-width: 768px) {
      .login-wrapper { flex-direction: column; }
      .login-left { padding: 40px 24px; flex: none; min-height: 200px; }
      .login-right { width: 100%; flex: 1; padding: 32px 24px; }
    }
  `]
})
export class LoginComponent implements AfterViewInit {
  private auth = inject(AuthService);

  ngAfterViewInit(): void {
    this.auth.showLock();
  }
}
